import React, { useState } from 'react';
import Plongeon from './components/plongeon/plongeon';
import { Button } from './components/shared/button/button';
import './App.css';
import Fondue from './components/fondue/fondue';
import Ski from './components/ski/ski';

export enum GameEnum {
  Home = "home",
  Plongeon = "plongeon",
  Fondue = "fondue",
  Ski = "ski"
}

export interface GameComponentArgs {
  setCurrentGame: (game: GameEnum) => void
}


function App() {
  const [currentGame, setCurrentGame] = useState<GameEnum>(GameEnum.Home)

  let gameElement;

  switch (currentGame) {
    case GameEnum.Home: {
      const goToPlongeon = () => { setCurrentGame(GameEnum.Plongeon) };
      const goToFondue = () => { setCurrentGame(GameEnum.Fondue) };
      const goToSki = () => { setCurrentGame(GameEnum.Ski) };
      gameElement = <div className="home" style={{ backgroundImage: 'url(/fond_home.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <Button className="home-btn top-left" onClick={goToPlongeon}>Aller à sciez</Button>
        <Button className="home-btn center" onClick={goToFondue}>C'est l'heure de la fondue !</Button>
        <Button className="home-btn top-right" onClick={goToSki}>Aller skier !</Button>
      </div>
      break;
    }
    case GameEnum.Plongeon: {
      gameElement = <Plongeon setCurrentGame={setCurrentGame}/>
      break;
    }
    case GameEnum.Fondue: {
      gameElement = <Fondue setCurrentGame={setCurrentGame}/>
      break;
    }
    case GameEnum.Ski: {
      gameElement = <Ski setCurrentGame={setCurrentGame}/>
      break;
    }
  }

  return (
    <div className="App">
      {gameElement}
    </div>
  );
}

export default App;
